<template>
  <div class="framer-14evfl3-container" @click="()=>openFaqQuestion()" >
    <div v-if="faqQuestionOpened === false"
      class="framer-cz38k framer-mp0BS framer-Wyb5v framer-Q1hGh framer-K9AN7 framer-pXM92 framer-bLVSP framer-uBkTj framer-CGGdA framer-tLYqA framer-5vvf4d framer-v-19km9ko"
      data-border="true" data-framer-name="Closed" data-highlight="true"
      style="--border-bottom-width: 1px; --border-color: rgb(214, 214, 214); --border-left-width: 1px; --border-right-width: 1px; --border-style: solid; --border-top-width: 1px; background-color: rgb(245, 245, 245); border-radius: 20px; width: 100%; opacity: 1;"
      tabindex="0">
      <div class="framer-1b6ipyg" style="opacity: 1;">
        <div class="framer-1202a2r" style="opacity: 1;">
          <div class="framer-1acr7qh"
            style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-a0htzi: var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --framer-paragraph-spacing: 0px; transform: none; opacity: 1;"
            data-framer-component-type="RichTextContainer">
            <h6 class="framer-text framer-styles-preset-w98w3a" data-styles-preset="HNXRxYFmQ">{{ titleFaqQuestion }} </h6>
          </div>
          <div class="framer-1w8k7ng" style="transform: rotate(45deg); opacity: 1;">
            <div data-framer-component-type="SVG" data-framer-name="Icon" radius="0"
              style="image-rendering: pixelated; flex-shrink: 0; opacity: 1;" class="framer-1xaqfqa"
              aria-hidden="true">
              <div class="svgContainer" style="width:100%;height:100%;aspect-ratio:inherit"><svg
                  style="width:100%;height:100%">
                    <svg viewBox="0 0 24 24">
                      <path d="M 17 7 L 7 17 M 7 7 L 12.03 12.03 L 17 17" fill="transparent" stroke-width="2"
                        stroke="var(--token-fbf0164e-dee2-4e19-9b25-5c9f4ebdcda6, rgb(91, 94, 118))" stroke-linecap="round"
                        stroke-miterlimit="10" stroke-dasharray=""></path>
                    </svg>
                </svg></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else
      class="framer-cz38k framer-mp0BS framer-Wyb5v framer-Q1hGh framer-K9AN7 framer-pXM92 framer-bLVSP framer-uBkTj framer-CGGdA framer-tLYqA framer-5vvf4d framer-v-5vvf4d"
      data-border="true" data-framer-name="Open" data-highlight="true" tabindex="0"
      style="--border-bottom-width: 1px; --border-color: rgb(214, 214, 214); --border-left-width: 1px; --border-right-width: 1px; --border-style: solid; --border-top-width: 1px; background-color: var(--token-a0c2593c-6916-4188-ac50-f5131b23cc3f, rgb(255, 255, 255)); width: 100%; border-radius: 20px; transform: none; transform-origin: 50% 50% 0px;">
      <div class="framer-1b6ipyg" style="transform: none; transform-origin: 50% 50% 0px;">
        <div class="framer-1202a2r" style="transform: none; transform-origin: 50% 50% 0px; height: 100%;">
          <div class="framer-1acr7qh" data-framer-component-type="RichTextContainer"
            style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-a0htzi: var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --framer-paragraph-spacing: 0px; transform: none; transform-origin: 50% 50% 0px;">
            <h3 class="framer-text"
              style="--font-selector: Q1VTVE9NO1B1YmxpY2EgU2FucyBCb2xk; --framer-font-family: &quot;Publica Sans Bold&quot;, &quot;Publica Sans Bold Placeholder&quot;, sans-serif; --framer-font-size: 18px; --framer-letter-spacing: 0px; --framer-text-color: var(--extracted-a0htzi, var(--token-72e8df52-57a2-46b1-82a3-f1511a4cdd86, rgb(16, 16, 16)));">
              {{ titleFaqQuestion }}</h3>
          </div>
          <div class="framer-1w8k7ng"
            style="transform: rotate(-90deg); will-change: transform; transform-origin: 50% 50% 0px;">
            <div data-framer-component-type="SVG" data-framer-name="Icon" radius="0" class="framer-1xaqfqa"
              aria-hidden="true"
              style="image-rendering: pixelated; flex-shrink: 0; transform: none; transform-origin: 50% 50% 0px;">
              <div class="svgContainer" style="width: 100%; height: 100%; aspect-ratio: inherit;"><svg
                  style="width:100%;height:100%">
                    <svg viewBox="0 0 24 24">
                      <path d="M 17 7 L 7 17 M 7 7 L 12.03 12.03 L 17 17" fill="transparent" stroke-width="2"
                        stroke="var(--token-fbf0164e-dee2-4e19-9b25-5c9f4ebdcda6, rgb(91, 94, 118))" stroke-linecap="round"
                        stroke-miterlimit="10" stroke-dasharray=""></path>
                    </svg>
                </svg></div>
            </div>
          </div>
        </div>
        <div class="framer-efjpz6" data-framer-component-type="RichTextContainer"
          style="outline: none; display: flex; flex-direction: column; justify-content: flex-start; flex-shrink: 0; --extracted-r6o4lv: var(--token-fbf0164e-dee2-4e19-9b25-5c9f4ebdcda6, rgb(102, 102, 102)); --framer-link-text-color: rgb(0, 153, 255); --framer-link-text-decoration: underline; --framer-paragraph-spacing: 0px; transform: none; transform-origin: 50% 50% 0px;">
          <div style="display: flex; flex-direction: column;" v-html="descFaqQuestion"/>
          <img v-if="projectFlowImage === true" :src="projectflow"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import projectflow from "@/assets/ProcessFlowProject.png";

export default {
  name: 'faq-question',
  inheritAttrs: false,
  data() {
    return {
      faqQuestionOpened: false,
      projectflow
    }
  },
  methods: {
    openFaqQuestion() {
      this.faqQuestionOpened = !this.faqQuestionOpened
    }
  },
  props: {
    titleFaqQuestion: {
      type: String
    },
    descFaqQuestion: {
      type: String
    },
    projectFlowImage: {
      type: Boolean
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/sfera/components/FaqQuestion/index.vue